module.exports = __webpack_public_path__ + "img/PBschoolpay.bc4bc481.jpg";